import { connect } from 'react-redux';

import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { AppState } from '../../bootstrap/redux/state/AppState';
import { ContentInfoCardChannel, ContentInfoChannelOwnProps, ContentInfoChannelProps } from '../../home/components/ContentInfoCardChannel';
import { ChannelTypes } from '../../home/types/ChannelTypes';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { DataMonitoringExplanation, PopularExplanation,SimiliarUsersExplanation } from '../models/IViewRecommendationInfo';

export const ConnectedRecommendationsChannel = connect((state: AppState, props: ContentInfoChannelOwnProps) => {
  const explanationType = mapChannelTypeToExplanationType(props.channelType);
  const recsList: IContentInfo[] = state.recommendations.recommendationsChannelState.items
    .map(contentId => state.normalizedContentById[contentId]).filter(rec => rec.explanationType === explanationType);

  // numCardsToShow will be 0 if the initial show more state hasn't been set yet
  const numRows: number = props.maxCardsPerRow > 0 && props.numCardsToShow > 0 ? Math.ceil(props.numCardsToShow / props.maxCardsPerRow) : 1;

  const recommendationChannelProps: ContentInfoChannelProps = {
    channelType: props.channelType,
    shouldListWrapVertically: true,
    title: props.title,
    seeAllUrl: '',
    seeAllAltText: '',
    list: recsList,
    numCardsToShow: props.numCardsToShow,
    isFetching: state.home.recommendations.isFetching,
    numRows,
    maxCardsPerRow: props.maxCardsPerRow,
    spaceInfo: selectSpaceInfo(state),
    headerIconPath: props.headerIconPath || '',
    showMoreCards: props.showMoreCards
  };
  return recommendationChannelProps;
})(ContentInfoCardChannel);

function mapChannelTypeToExplanationType(channelType: ChannelTypes): string {
  if (channelType === ChannelTypes.recsSimilarUsers) {
    return SimiliarUsersExplanation;
  } else if (channelType === ChannelTypes.recsDataMonitoring) {
    return DataMonitoringExplanation;
  } else if (channelType === ChannelTypes.recsPopular) {
    return PopularExplanation;
  }
  return '';
}
